import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "/index.php";

const getQueryParamsFromFilters = (filters) => {
    const queryParams = [];

    const {
        startDate,
        endDate,
        positions,
        violationTypes,
        positionsExcept,
        violationTypesExcept,
        onlyImportantViolations,
    } = filters;

    if (positions.length > 0) {
        positions.forEach((position) => {
            queryParams.push(`posts[]=${position.value}`);
        });
        if (positionsExcept) {
            queryParams.push("exclPosts=1");
        }
    }
    if (violationTypes.length > 0) {
        violationTypes.forEach((position) => {
            queryParams.push(`categories[]=${position.value}`);
        });
        if (violationTypesExcept) {
            queryParams.push("exclCategories=1");
        }
    }
    if (!onlyImportantViolations) {
        queryParams.push("show_all_foul_types=1");
    }
    if (startDate && endDate) {
        queryParams.push("period=custom");
        queryParams.push(`start=${startDate}&finish=${endDate}`);
    }

    return queryParams;
};

const state = () => ({
    reportRecords: {},
    collections: {
        positions: [],
        violationTypes: [],
    },
    queryForGoogleSheets: [],
});

const getters = {
    filials(state) {
        if (!state.reportRecords || !state.reportRecords.filials) {
            return [];
        }
        return Object.values(state.reportRecords.filials);
    },
    workers(state) {
        if (!state.reportRecords || !state.reportRecords.filials) {
            return [];
        }
        return Object.values(state.reportRecords.filials).reduce((acc, currentFilial) => {
            const workers = Object.values(currentFilial.workers).map((worker) => ({
                ...worker,
                filialId: currentFilial.id,
            }));
            acc = [...acc, ...workers];
            return acc;
        }, []);
    },
    violationTypes(state) {
        if (!state.reportRecords || !state.reportRecords.categories) {
            return [];
        }
        return Object.values(state.reportRecords.categories).sort((a, b) => b.sort - a.sort);
    },
    workerPoints(state) {
        if (!state.reportRecords || !state.reportRecords.categories) {
            return [];
        }
        return Object.values(state.reportRecords.data).reduce((acc, currentFilial) => {
            acc = { ...acc, ...currentFilial.workers };
            return acc;
        }, {});
    },
    noReportRecordsFound(state) {
        return Object.keys(state.reportRecords).length === 0 || Object.keys(state.reportRecords.data).length === 0;
    },
};

const actions = {
    async fetchReportRecords({ rootState, commit }, filters) {
        const token = rootState.authToken;
        const queryParams = getQueryParamsFromFilters(filters);
        commit("setQueryForGoogleSheets", queryParams);

        const url = addAuthKey(`${apiUrl}?r=api/foul-report/index&${queryParams.join("&")}`, token);
        const { data } = await axios.get(url);

        commit("setReportRecords", data);
    },
    async fetchPositions({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/directory/position`, token);

        const { data } = await axios.get(url);
        const positions = Object.entries(data).map(([positionCode, { name }]) => ({
            label: name,
            value: positionCode,
        }));

        commit("setPositions", positions);
    },
    async fetchViolationTypes({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/foul-category/index&withoutCategory=1`, token);

        const { data } = await axios.get(url);
        const types = data.map((type) => ({ label: type.name, value: type.id ? type.id : "" }));

        commit("setViolationTypes", types);
    },
};

const mutations = {
    setReportRecords(state, records) {
        const { data, filials, categories } = records;
        const researchedCategories = {};
        Object.entries(categories).forEach(([key, value]) => {
            if (value.id === null) {
                value.id = "";
                value.name = "Без категории";
            }
            researchedCategories[key] = value;
        });
        state.reportRecords = { data, filials, categories: researchedCategories };
    },
    setPositions(state, positions) {
        state.collections.positions = positions;
    },
    setViolationTypes(state, types) {
        state.collections.violationTypes = types;
    },
    setQueryForGoogleSheets(state, query) {
        state.queryForGoogleSheets = query;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
